import React from 'react';
import { useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import { push } from 'connected-react-router';
import moment from 'moment';
import FormViewButton from 'components/Common/Buttons/FormViewButton';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import FormTypes from 'common/Forms/FormTypes';

const LinkedImyStructure = ({ structure, permissions }) => {
  const dispatch = useDispatch();

  const navigateToImyStructure = (form) => {
    if (form.topLevelAccountId !== null) {
      dispatch(push(`/w8imystructure/${ form.topLevelAccountId }`));
    }
  };

  const navigateToDigitalWhsStatement = (form) => {
    if (form.topLevelAccountId !== null) {
      dispatch(push(`/whd-statement/${ form.topLevelAccountId }`));
    }
  };

  const buildFormObject = () => {
    const formType = structure && structure.formType && FormTypes.getByValue(structure.formType);
    const formObject = {
      accountId: structure.topLevelAccountId,
      formId: structure.formId,
      formType: formType && formType.code,
      workflowStatus: structure.workflowStatus,
      workflowUsername: structure.workflowUsername ? structure.workflowUsername : 'N/A',
      workflowUserFullName: structure.workflowUserFullName
    };
    return formObject;
  };

  function dateFormatter(value, format) {
    return moment(value).format(format);
  }

  function getEffectiveDate(date) {
    if (date !== null) {
      return `${ dateFormatter(date, 'MMM DD, YYYY') }`;
    }
    return 'N/A';
  }

  return (
    <div style={ { display: 'flex' } } key={ structure.formId }>
      <div className="col-5 mr-10">
        <div className="columns" style={ { margin: 0 } }>
          <div className="col-4 panel-item-name"><b><p id="linked-imy-intermediary-name-name">Intermediary Name</p></b></div>
          <div className="col-8 panel-item-value"><p id="linked-imy-intermediary-name-value">{ structure.topLevelCustomerName }</p></div>
        </div>
        <div className="columns" style={ { margin: 0 } }>
          <div className="col-4 panel-item-name"><b><p id="linked-imy-intermediary-account-name">Intermediary Account</p></b></div>
          <div className="col-8 panel-item-value"><p id="linked-imy-intermediary-account-value">{ structure.topLevelAccount }</p></div>
        </div>
        <div className="columns" style={ { margin: 0 } }>
          <div className="col-4 panel-item-name"><b><p id="linked-imy-intermediary-uploaded-date-name">Uploaded</p></b></div>
          <div className="col-8 panel-item-value"><p id="linked-imy-intermediary-uploaded-date-value">{ getEffectiveDate(structure.uploadedDate) }</p></div>
        </div>
        <div className="columns" style={ { margin: 0 } }>
          <div className="col-4 panel-item-name"><b><p id="linked-imy-intermediary-linked-date-name">Linked</p></b></div>
          <div className="col-8 panel-item-value"><p id="linked-imy-intermediary-linked-date-value">{ getEffectiveDate(structure.effectiveFrom) }</p></div>
        </div>
      </div>
      <div className="col-7">
        <p>View options</p>
        <div className="col-12">
          { structure.formId > 0 && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate])
                 && <FormViewButton
                   permissions={ permissions }
                   formId={ structure.formId }
                   form={ buildFormObject() }
                   accountId={ structure.topLevelAccountId }
                   content={ <React.Fragment><i className="icon icon-apps mr-2" />IMY Form</React.Fragment> }
                   className="btn btn-secondary mr-10"
                   title="View IMY Form"
                 /> }
          { structure.hasAllocationStatement && AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree]) && <button
            className="btn mr-10"
            type="button"
            title="View IMY Tree"
            onClick={ () => navigateToImyStructure(structure) }
            id="linked-imy-intermediary-view-tree-button"
          >
            <span className="icon icon-treeview mr-2" />
            IMY Tree
            </button> }
          { structure.hasAllocationStatement && AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrViewWhs]) && <button
            className="btn"
            type="button"
            title="View Digital Statement"
            onClick={ () => navigateToDigitalWhsStatement(structure) }
            id="linked-imy-intermediary-view-whs-button"
          >
            WHS
            </button> }
        </div>
      </div>
    </div>
  );
};

LinkedImyStructure.propTypes = {
  structure: PropTypes.shape().isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string)
};

LinkedImyStructure.defaultProps = {
  permissions: null
};

export default LinkedImyStructure;
